// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__C2L2s","title":"ClientInsurance_title__2g-0C","itemText":"ClientInsurance_itemText__3CrS8"};